.search-icon{position:absolute;top:0;right:0;height:100%;z-index:100}input:focus{outline:none;box-shadow:none}::ng-deep .was-validated .ng-invalid+.search-icon{display:none}::ng-deep app-local-filter.dropdown-toggle:after{display:none}
/*# sourceMappingURL=multi-select.component-RSGK5KRJ.css.map */
